export default "https://legacy.eskolare-development.com/images/student-create.png";